import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { PromoActions, PromoSelectors, StateWithPromo } from '@promo/data-access';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EmailSubscriptionService {
  readonly loading$: Observable<boolean> = this.store.pipe(select(PromoSelectors.getEmailSubscriptionLoading));
  readonly success$: Observable<boolean> = this.store.pipe(select(PromoSelectors.getEmailSubscriptionSuccess));
  readonly error$: Observable<boolean> = this.store.pipe(select(PromoSelectors.getEmailSubscriptionError));

  constructor(private store: Store<StateWithPromo>) {}

  subscribe(email: string, isLoggedIn: boolean): void {
    this.store.dispatch(new PromoActions.SubscribeEmail(email, isLoggedIn));
  }

  reset(): void {
    this.store.dispatch(new PromoActions.SubscribeEmailReset());
  }
}
